import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import format from 'date-fns/format'
import _ from 'lodash'
// import startOfWeek from 'date-fns/start_of_week';
// import endOfWeek from 'date-fns/end_of_week';
// import startOfMonth from 'date-fns/start_of_month';
import endOfMonth from 'date-fns/end_of_month';
import addMinutes from 'date-fns/add_minutes';
// import addDays from 'date-fns/add_days';
import addMonths from 'date-fns/add_months';
import moment from 'moment';
import axios from 'axios';
import { getTeamByCompany, getUserAll } from './core/cacheService';

// Helper function to ensure multilingual field has fallbacks
function ensureFallbacks(multilingualObj: any): any {
  if (!multilingualObj) return { en: '' };
  if (typeof multilingualObj === 'string') return { en: multilingualObj };
  const result = { ...multilingualObj };
  // If Thai is missing, copy from English
  if (!result.th) result.th = result.en || '';
  return result;
}

// Helper function to get text value from multilingual object
function getTextValue(field: any, defaultValue: string = ''): string {
  if (!field) return defaultValue;
  if (typeof field === 'string') return field;
  if (typeof field === 'object') return field.en || defaultValue;
  return defaultValue;
}

// Process multilingual fields and add backward compatibility fields
function processMultilingualFields(form: any): any {
  const processedForm = { ...form };
  
  // Process campaignCategory
  if (form.campaignCategory && typeof form.campaignCategory === 'object') {
    processedForm.campaignCategory = ensureFallbacks(form.campaignCategory);
    processedForm.campaignCategory_en = form.campaignCategory.en || '';
    processedForm.campaignCategory_display = form.campaignCategory.th || form.campaignCategory.en || '';
  }
  
  // Process title
  if (form.title && typeof form.title === 'object') {
    processedForm.title = ensureFallbacks(form.title);
    processedForm.title_en = form.title.en || '';
    processedForm.title_display = form.title.th || form.title.en || '';
  }
  
  // Process description
  if (form.description && typeof form.description === 'object') {
    processedForm.description = ensureFallbacks(form.description);
    processedForm.description_en = form.description.en || '';
    processedForm.description_display = form.description.th || form.description.en || '';
  }
  
  // Process goals.unit
  if (form.goals && form.goals.unit) {
    if (typeof form.goals.unit === 'object') {
      processedForm.goals = {
        ...form.goals,
        unit: ensureFallbacks(form.goals.unit),
        unit_en: form.goals.unit.en || 'items',
      };
    }
  }
  
  // Process checklist items
  if (form.checklistItems && Array.isArray(form.checklistItems)) {
    processedForm.checklistItems = form.checklistItems.map((item: any) => {
      if (typeof item === 'object') {
        return ensureFallbacks(item);
      }
      return { en: item || '' };
    });
    // Also create a flat array for legacy display
    processedForm.checklistItems_display = form.checklistItems.map((item: any) => {
      return getTextValue(item, '');
    }).filter((item: string) => item.trim() !== '');
  }
  
  // Process quiz questions
  if (form.quizQuestions && Array.isArray(form.quizQuestions)) {
    processedForm.quizQuestions = form.quizQuestions.map((q: any) => {
      const processedQuestion: any = { ...q };
      
      // Process question text
      if (q.question && typeof q.question === 'object') {
        processedQuestion.question = ensureFallbacks(q.question);
        processedQuestion.question_en = q.question.en || '';
        processedQuestion.question_display = q.question.th || q.question.en || '';
      }
      
      // Process options
      if (q.options && typeof q.options === 'object' && !Array.isArray(q.options)) {
        // Multilingual format: { en: [...], th: [...] }
        processedQuestion.options = q.options;
        // Ensure fallbacks for options
        if (!processedQuestion.options.th) {
          processedQuestion.options.th = processedQuestion.options.en || [];
        }
        // Create flat array for legacy display (English)
        processedQuestion.options_display = q.options.en || [];
      }
      
      return processedQuestion;
    });
  }
  
  return processedForm;
}

export default {
  namespaced: true,
  state: {
    sessions_all: [],
    sessions: [],
    inputSearchSessions: "",
    sessionsSortBy: "class_name",
    sessionResults: 0,
    sessionPage: 1,
    sessionSortField: "",
    sessionSortOrder: "ascending",
    sessionTypingStatus: null,
    university_total: 0,
    size_page: 10,
    topicOpt: [],
    university_total16:0,
    university_graphmonth:[],
    university_graphmonth16:[],
    university:[],
    universityall:[],
    loadingUniversitySessionsTable: true,
    huddleTagData:[],
    huddleTag:{},
    comment:[],
    commentId:'',
    userAll:{},
    member:[],
    organization1level:{},
    // Campaigns state
    // TODO(backend): Campaign Model Schema for Backend Integration
    // Collection: university_campaigns (Firestore recommended)
    // Fields:
    //   - id: string (auto-generated)
    //   - company: string (for filtering; avoid composite indexes, filter dates client-side)
    //   - title: string (required)
    //   - iconKey: string (icon filename without extension, e.g., "ic_star_24px")
    //   - theme: { gradientKey: string, accentHex: string }
    //   - inputType: enum("quiz", "auto_sync_steps", "auto_sync_sleep", "auto_sync_screen", 
    //                     "auto_sync_exercise", "auto_sync_water", "auto_sync_calories",
    //                     "multiple_selection", "yes_no")
    //   - timing: { 
    //       frequency: enum("daily", "weekly"), 
    //       startDate: ISO string, 
    //       endDate: ISO string (calculated from startDate + occurrences),
    //       occurrences: number (number of days/weeks the campaign runs)
    //     }
    //   - goals: { 
    //       dailyEnabled: true (always required), 
    //       dailyTarget: number (daily goal per occurrence, 1 for yes_no type),
    //       individualEnabled: true (always required), 
    //       individualTarget: number (overall individual goal),
    //       groupEnabled: boolean (optional), 
    //       groupTarget?: number (overall group goal, only if groupEnabled)
    //     }
    //   Note: Daily and Individual goals are REQUIRED. Group goal is OPTIONAL.
    //   For Yes/No type: dailyTarget is always 1 (binary success per day).
    //   - reward: { 
    //       type: enum("instant", "charged", "prize_pool"), 
    //       coins?: number, 
    //       chargedCoins?: number,
    //       multipleSelectionRule?: enum("per_item", "daily_goal") // Only for multiple_selection type
    //     }
    //   - entryCost: number (coins required to join)
    //   - quizQuestions?: array of { question: string, options: string[], correctAnswer: number }
    //   - status: enum("draft", "active", "upcoming", "ended", "archived")
    //   - createdBy: string (email)
    //   - createdAt: ISO string
    //   - participants?: number (count of users who joined)
    //
    // Goal Types Explained:
    //   - Daily Goal: Target to achieve each day/week (e.g., 10,000 steps per day)
    //   - Individual Overall Goal: Cumulative target for the entire campaign (e.g., 300,000 total steps)
    //   - Group Overall Goal: Combined target for all participants (e.g., 10M total steps)
    //
    // Multiple Selection Reward Rules:
    //   - per_item: Participants earn rewards for each item they complete, only after daily goal is reached
    //   - daily_goal: Participants only earn rewards when daily goal is reached
    //
    // Quiz Questions:
    //   - Array length should match occurrences (one question per day/week)
    //   - Each question has 4 options (multiple choice)
    //   - correctAnswer is the index (0-3) of the correct option
    //
    // Prize Pool Rule (for backend implementation):
    //   When reward.type === "prize_pool":
    //   - Total pool = sum of entryCost from all participants
    //   - At campaign endDate, split pool equally among users who achieved the goal
    //   - Example: 100 participants × 20 coins entry = 2000 coin pool
    //             If 25 achieve goal → each gets 2000/25 = 80 coins
    campaigns_all: [],
    campaigns: [],
    campaignsFilter: 'all',
    campaignsPage: 1,
    loadingCampaigns: false,
    campaignSummaries: {} as Record<string, any>, // Indexed by campaign_id
  },
  mutations: {
    setTopicOption(state:any, result:any){
      state.topicOpt = result
    },
    setAllUniversity(state:any, result:number){
      state.university_total = result
    },
    setAllUniversity16(state:any, result:number){
        state.university_total16 = result
    },
    setGraphMonth(state:any, result:any){
      state.university_graphmonth = result
    },
    setGraphMonth16(state:any, result:any){
        state.university_graphmonth16 = result
    },
    setUniversity(state:any, result:any){
      state.university = result
    },
    setUniversityAll(state:any, result:any){
        state.universityall = result
    },
    setSessionAll(state: any, result: any) {
      state.sessions_all = result
    },
    setSession(state: any, result: any) {
      state.sessions = result
    },
    setInputSearchSessions(state: any, value: any) {
      state.inputSearchSessions = value.keyword
    },
    setSessionResults(state: any, result: any) {
      state.sessionResults = result
    },
    setSessionPage(state: any, result: any) {
      state.sessionPage = result
    },
    setSessionSortField(state: any, result: any) {
      state.sessionSortField = result
    },
    setSessionSortOrder(state: any, result: any) {
      state.sessionSortOrder = result
    },
    setSessionTypingStatus(state: any, status: any) {
      state.sessionTypingStatus = status
    },
    setLoadingSessionsTable(state: any, result: any) {
      state.loadingUniversitySessionsTable = result
    },  
    setHuddleTag(state: any, result: any) {
      state.huddleTagData = result
    },
    setComment(state: any, result: any) {
      state.comment = result
    },
    setCommentID(state: any, result: any) {
      state.commentId = result
    },
    setUserAll(state: any, result: any) {
      state.userAll = result
    },
    setMember(state: any, result: any) {
      state.member = result
    },
    setOrganization1level(state:any, result:any) {
      state.organization1level = result
    },
    // Campaigns mutations
    setCampaigns(state:any, campaigns:any) {
      state.campaigns_all = campaigns;
      state.campaigns = campaigns;
    },
    setCampaignsPage(state:any, page:any) {
      state.campaignsPage = page;
    },
    setCampaignsFilter(state:any, filter:any) {
      state.campaignsFilter = filter;
    },
    setLoadingCampaigns(state:any, loading:any) {
      state.loadingCampaigns = loading;
    },
    upsertCampaign(state:any, campaign:any) {
      const index = state.campaigns_all.findIndex((c:any) => c.id === campaign.id);
      if (index >= 0) {
        state.campaigns_all.splice(index, 1, campaign);
      } else {
        state.campaigns_all.unshift(campaign);
      }
      state.campaigns = [...state.campaigns_all];
    },
    archiveCampaignLocal(state:any, id:any) {
      const index = state.campaigns_all.findIndex((c:any) => c.id === id);
      if (index >= 0) {
        state.campaigns_all[index].status = 'archived';
      }
      state.campaigns = [...state.campaigns_all];
    },
    setCampaignSummaries(state:any, summaries:any) {
      state.campaignSummaries = summaries;
    },
    setCampaignSummary(state:any, { campaignId, summary }:any) {
      state.campaignSummaries = {
        ...state.campaignSummaries,
        [campaignId]: summary
      };
    },
  },
  actions: {
    async getUniversity({ commit, rootState, state }: any){
      const dateNow = new Date()
      const months: Array<any> = [];
      const months16: Array<any> = [];
      const yearnow = format(dateNow, 'YYYY')
      //const universities_by_month: Array<any> = [];
      for(let x=0; x<6; x++){
          const enddate = format(endOfMonth(addMonths(dateNow, -x)), 'YYYY-MM')
          const year = format(endOfMonth(addMonths(dateNow, -x)), 'YYYY')
          if(yearnow !== year){
              months[enddate] = {
                  month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM ‘YY'),
                  value:0
              }
          }else{
              months[enddate] = { 
                  month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM'),
                  value:0
              }
          }
      }
      for(let x=0; x<16; x++){
          const enddate = format(endOfMonth(addMonths(dateNow, -x)), 'YYYY-MM')
          const year = format(endOfMonth(addMonths(dateNow, -x)), 'YYYY')
          if(yearnow !== year){
              months16[enddate] = {
                  month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM ‘YY'),
                  value:0
              }
          }else{
              months16[enddate] = { 
                  month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM'),
                  value:0
              }
          }
      }
      const topics = (await firebase.database().ref(`/topic_session/`).once('value')).val();
      let topic: Array<any> = [];
      for(const x in topics){
          topics[x].key = rootState.authen.user.company+'-'+x;
          topics[x].follower = 0;
          topic.push(topics[x]);
      }
      const topicsMaster: Array<any> = [];
      await firebase.firestore().collection('classrooms_topic').where("company", "==", rootState.authen.user.company).get().then((query)=>{
          query.forEach((doc) => {
              topicsMaster[doc.id] = doc.data();

              if(doc.data().delete === undefined){
                  if(doc.data().master_id === undefined){
                      const data = doc.data();
                      data.key = doc.id;
                      topic.push(data);
                  }else{
                      const i = _.findIndex(topic, function (el) {
                          return el.key === doc.data().master_id;
                      });
                      topic[i].follower = doc.data().follower;
                  }
              }else{
                  const i = _.findIndex(topic, function (el) {
                      return el.key === doc.data().master_id;
                  });
                  if(i>=0) topic.splice(i, 1);
              }
          });
          
          topic =  _.orderBy(topic, ['name'], ['asc']);
      });
      return new Promise(( res, rej ) => {
          firebase.firestore().collection('classrooms').where("company", "in", [rootState.authen.user.company,rootState.authen.user.company+'-huddles']).orderBy('create_date','desc').get()
          .then(async (querySnapshot)=> {
              const universities: Array<any> = [];
              const universitiesall: Array<any> = [];
              let all_university = 0;
              let all_university16 = 0;
              querySnapshot.forEach((doc) => {
                  const university = doc.data()
                  university.key = doc.id
                  if(university.create_user=='happily_charracter'){
                    university.create_name_character = university.create_name;
                  }else{
                    const name = university.create_name.split(' ')
                    if(name.length>1){
                      university.create_name = `${name[0]} ${name[1].charAt(0)}`
                    }else{
                      university.create_name = name[0]
                    }
                  }
                  university.topic_name = '';
                  university.create_name_character = university.create_name_character;
                  university.create_user = university.create_user;

                  // university.class_datetime = format(university.class_datetime, 'MMM D, YYYY [at] H:mm A');
                  if(doc.data().topic_id){
                      university.topic_name = (topicsMaster[doc.data().topic_id] && topicsMaster[doc.data().topic_id].name)?topicsMaster[doc.data().topic_id].name:''
                  }
                  if(universities.length < 4)
                  universities.push(university)
                  universitiesall.push(university)
                  const d = university.create_date.split(' ');
                  const date = d[0].split('-');
                  const enddate = format(new Date(date[0],(date[1]-1),date[2]), 'YYYY-MM')
                  if(months[enddate] !== undefined){
                      months[enddate].value += university.signup.length
                      all_university += university.signup.length
                  }
                  if(months16[enddate] !== undefined){
                      months16[enddate].value += university.signup.length
                  }
                  all_university16 += university.signup.length
              });
              
              // Also fetch campaign participant counts and add to the chart
              try {
                  // First, get all campaigns to have their timing data
                  const campaignsSnapshot = await firebase.firestore()
                      .collection('universityCampaigns')
                      .where('company', '==', rootState.authen.user.company)
                      .get();
                  
                  const campaignTimings: Record<string, any> = {};
                  campaignsSnapshot.forEach((doc) => {
                      const campaign = doc.data();
                      if (campaign.timing && campaign.timing.startDate) {
                          campaignTimings[doc.id] = campaign.timing.startDate;
                      }
                  });
                  
                  // Then get summaries for participant counts
                  const campaignSummariesSnapshot = await firebase.firestore()
                      .collection('campaign_overall_summary')
                      .where('company', '==', rootState.authen.user.company)
                      .get();
                  
                  campaignSummariesSnapshot.forEach((doc) => {
                      const summary = doc.data();
                      const campaignId = summary.campaign_id || doc.id;
                      const participantCount = summary.leaderboard ? summary.leaderboard.length : 0;
                      
                      if (participantCount > 0) {
                          // Get start date from campaign timing or summary
                          let startDateValue = campaignTimings[campaignId] || summary.start_date;
                          let startDate: Date | null = null;
                          
                          if (startDateValue) {
                              if (startDateValue.toDate) {
                                  startDate = startDateValue.toDate();
                              } else if (typeof startDateValue === 'string') {
                                  startDate = new Date(startDateValue);
                              } else if (startDateValue instanceof Date) {
                                  startDate = startDateValue;
                              }
                          }
                          
                          if (startDate && !isNaN(startDate.getTime())) {
                              const monthKey = format(startDate, 'YYYY-MM');
                              if (months[monthKey] !== undefined) {
                                  months[monthKey].value += participantCount;
                                  all_university += participantCount;
                              }
                              if (months16[monthKey] !== undefined) {
                                  months16[monthKey].value += participantCount;
                              }
                              all_university16 += participantCount;
                          }
                      }
                  });
              } catch (campaignError) {
                  console.error('Error fetching campaign data for chart:', campaignError);
              }
              
              //console.log('university',universities)
              commit('setTopicOption', topic)
              commit('setAllUniversity', all_university16)
              commit('setAllUniversity16', all_university16)
              commit('setGraphMonth', months)
              commit('setGraphMonth16', months16)
              commit('setUniversity', universities)
              commit('setUniversityAll', universitiesall)
              commit("setSession", universitiesall.slice(0, state.size_page));
              commit("setSessionAll", universitiesall);
              commit("setSessionResults", universitiesall.length);
              commit('setLoadingSessionsTable', false)
              res();
          });
      });
    },
    searchSessions({ commit, state, dispatch }: any, data: any) {
      clearTimeout(state.sessionTypingStatus)
      state.sessionTypingStatus = setTimeout(() => {
        commit('setSessionPage', 1)
        if (data.value.length > 0) {
          dispatch('sortSesstions', {
            0: state.sessionSortField,
            1: state.sessionSortOrder,
            3: data.value
          })
        } else if (data.value.length == 0) {
          let sessions: Array<any> = [];
          sessions = state.sessions_all
          commit('setSessionResults', sessions.length)
          commit('setSession', sessions.slice(0, state.size_page))
        }
      }, data.typingTimeout)
    },
    sortSesstions({ commit, state }: any, value: any) {
      // let sessions: Array<any> = [];
      // sessions.push(state.sessions_all)
      // let textSearching = value[3] || state.inputSearchSessions;
      // if (textSearching.length > 0) {
      //   if (sessions.length > 0) {
      //     let re = new RegExp(textSearching, 'gi')
      //     let response = _.filter(sessions[0], (item): any => {
      //       if (item.class_name.match(re)) {
      //         return true
      //       } else if (item.create_name != undefined && item.create_name.match(re)) {
      //         return true
      //       } else if (item.topic_name != undefined && item.topic_name.match(re)) {
      //         return true
      //       }
      //     });
      //     sessions = []
      //     sessions.push(response)
      //   }
      // }

      let field = value[0]
      commit('setSessionSortField', field)
      let order = value[1]
      commit('setSessionSortOrder', order)

      // let newSessions = {}
      // for (let i = 0; i < sessions[0].length; i++) {
      //   newSessions[i] = sessions[0][i]
      //   let time = sessions[0][i].class_datetime
      //   let class_datetime = time.split(" at").join(",")
      //   newSessions[i].timestamp = new Date(class_datetime.substring(0, class_datetime.length - 3)).getTime()
      // }
      // if (field === "signup" || field === "class_price" || field === "class_datetime") {
      //   if (order === "ascending") {
      //     order = 'desc'
      //   } else {
      //     order = 'asc'
      //   }
      // } else {
      //   if (order === "ascending") {
      //     order = 'asc'
      //   } else {
      //     order = 'desc'
      //   }
      // }
      // if (field === "class_datetime" || field === "") {
      //   field = "timestamp"
      // }
      // let _users
      // _users = _.orderBy(newSessions, [field], [order]);
      // commit('setSessionResults', _users.length)
      // commit('setSession', _users.slice(0, state.size_page))
    },
    currentSessionsChange({ commit, state }: any, page: any) {
      // let size = state.size_page
      // let start_row = (page - 1) * size
      // let end_row = ((page - 1) * size) + size
      // let sessions: Array<any> = [];
      // if (state.inputSearchSessions.length > 2) {
      //   let re = new RegExp(state.inputSearchSessions, 'gi')
      //   let response = _.filter(state.sessions_all, (item): any => {
      //     if (item.class_name.match(re)) {
      //       return true
      //     } else if (item.create_name != undefined && item.create_name.match(re)) {
      //       return true
      //     } else if (item.topic_name != undefined && item.topic_name.match(re)) {
      //       return true
      //     }
      //   });
      //   sessions = response
      // } else {
      //   sessions = state.sessions_all
      // }

      commit('setSessionPage', page)
      // commit('setSession', sessions.slice(start_row, end_row))
      // commit('setSession', state.sessions_all)
    },
    async createSession({commit,rootState,dispatch,state}:any,form:any){
      let data = form.form
      commit('setSession', [])
      commit('setLoadingSessionsTable', true)
      const creatorList = rootState.happilyvillageTownhall.creator
      
      let huddles=form.huddles
      let huddle: any[] = [];
      let filter=_.find(
        huddles,
        function (value) {
          return value == "everyone";
        }
      );  
      huddles.map(v=>{
        if(v!='everyone'){
          if(state.huddleTag[v].type=="houses"){
            huddle.push({
              key:state.huddleTag[v].value,
              value:state.huddleTag[v].label,
              selected:true,
              show:true,
              house:true
            })
          }else{
            huddle.push({
              key:state.huddleTag[v].value,
              value:state.huddleTag[v].label,
              selected:true,
              show:true,
              team:true
            })
          }

        }
      })
      let name_Creator = `${rootState.authen.user.firstname} ${rootState.authen.user.lastname}`
      let create_user = rootState.authen.user.email
      let happily_user = ''
      const creator = _.find(creatorList, function (el) {
        return el.name == data.creator;
      });
      //console.log('creator',creator)
      if(creator.character!=false){
        name_Creator = creator.character_name
        create_user = 'happily_charracter'
        happily_user = creator.characterpath
      }
      const classroom :any= {
        class_name: data.name,
        class_description: data.description,
        class_datetime: data.dateAndTime,
        class_location: data.location,
        class_limit: data.sessionLimit * 1,
        class_minimum: data.sessionMinimum * 1,
        class_price: (data.price !== undefined && data.price !== '')?data.price * 1:0,
        company: rootState.authen.user.company,
        create_name: name_Creator,
        create_user: create_user,
        happily_user:happily_user,
        // create_user: 'frame.yuranan@gmail.com', /*FIX*/
        minutes: Number(data.duration),
        comment_type: Number(data.commentPermission),
        topic_id: (data.topic) ? data.topic : '',
        sharelink: '',
        signup: [],
        calculate: 'N',
        create_date: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
      }
      if(happily_user==''){
        delete classroom['happily_user']
      }
      if(!filter){
        classroom["huddles"]=huddle
      }
      const ref = firebase.firestore().collection('classrooms').doc();
      const myId = ref.id;
      firebase.firestore().collection('classrooms').doc(myId).set(classroom).then(docRef => {
        dispatch('getUniversity')
      });
    },
    async editSession({commit,rootState,dispatch,state}:any,obj:any){
      let data = obj.form
      commit('setSession', [])
      commit('setLoadingSessionsTable', true)
      const creatorList = rootState.happilyvillageTownhall.creator
      let huddles=obj.huddles
      let huddle: any[] = [];
      let filter=_.find(
        huddles,
        function (value) {
          return value == "everyone";
        }
      );  
      huddles.map(v=>{
        if(v!='everyone'){
          if(state.huddleTag[v].type=="houses"){
            huddle.push({
              key:state.huddleTag[v].value,
              value:state.huddleTag[v].label,
              selected:true,
              show:true,
              house:true
            })
          }else{
            huddle.push({
              key:state.huddleTag[v].value,
              value:state.huddleTag[v].label,
              selected:true,
              show:true,
              team:true
            })
          }

        }
      })
      let name_Creator = `${rootState.authen.user.firstname} ${rootState.authen.user.lastname}`
      let create_user = rootState.authen.user.email
      let happily_user = ''
      const creator = _.find(creatorList, function (el) {
        return el.name == data.creator;
      });
      //console.log('creator',creator)
      if(creator.character!=false){
        name_Creator = creator.character_name
        create_user = 'happily_charracter'
        happily_user = creator.characterpath
      }

      if(obj.id){
        const classroom :any= {
          class_name: data.name,
          class_description: data.description,
          class_datetime: data.dateAndTime,
          class_location: data.location,
          class_limit: data.sessionLimit * 1,
          class_minimum: data.sessionMinimum * 1,
          minutes: Number(data.duration),
          comment_type: Number(data.commentPermission),
          topic_id: (data.topic) ? data.topic : '',
          update_date: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          create_name: name_Creator,
          create_user: create_user,
          happily_user:happily_user,
        }

        if(data.google_event_id){
          const url = 'https://api-node.happily.ai/setting/change-detail-google-calendar-event'
          //const url = 'http://localhost:80/setting/change-detail-google-calendar-event'
          const headers = {
              'Content-Type': 'application/json',
          }
          const classroom_google = {
            eventId: data.google_event_id,
            summary: data.name,
            description: data.description,
            startDateTime: format(new Date(data.dateAndTime),"YYYY-MM-DDTHH:mm:ss+07:00"),
            endDateTime: format(addMinutes(new Date(data.dateAndTime), data.duration),"YYYY-MM-DDTHH:mm:ss+07:00"),
          }
          axios.post(url,classroom_google,{headers:headers})
        }
        if(happily_user==''){
          delete classroom['happily_user']
        }
        if(!filter){
          classroom["huddles"]=huddle
        }else{
          firebase.firestore().collection('classrooms').doc(obj.id).update({huddles: firebase.firestore.FieldValue.delete()})
        }
        firebase.firestore().collection('classrooms').doc(obj.id).update(classroom).then(() => {
          dispatch('getUniversity')
        })



      }
    },
    async deleteSession({commit,rootState,dispatch,state}:any,value:any){
      commit('setSession', [])
      commit('setLoadingSessionsTable', true)
      const id = value.key;
      delete value.key;
      value.class_id = id;
      value.delete_date = format(new Date(), 'YYYY-MM-DD HH:mm:ss');
      firebase.firestore().collection('classrooms_delete').add(value);
      firebase.firestore().collection('classrooms').doc(id).delete().then(() => {
        dispatch('getUniversity')
      })
    },
    async getHouseAndTeam({commit,rootState,dispatch,state}:any,obj:any){

      let huddleTagData:Array<any> =[
        {
          value: "everyone",
          label: "Everyone",
        },
      ]
      const teams = await getTeamByCompany(rootState.authen.user.company)
      for(const i in teams){
        const u = teams[i]
          u.key = i
          u.value = teams[i].name
          let data={
            value:  teams[i].key ,
            label:  u.name ,
            type:'team'
          }
          if(teams[i].key){
            state.huddleTag[teams[i].key]=data
          }
          
          huddleTagData.push(data);

      }
      // console.log("huddleTagData",huddleTagData)
      // firebase.database().ref('team').orderByChild("company").equalTo(`${rootState.authen.user.company}`).once('value', snapshot => {
          
      //   snapshot.forEach((arrData):any => {
      //     const u = arrData.val()
      //     u.key = arrData.key
      //     u.value = arrData.val().name
      //     let data={
      //       value:  arrData.key ,
      //       label:  u.name ,
      //       type:'team'
      //     }
      //     if(arrData.key){
      //       state.huddleTag[arrData.key]=data
      //     }
          
      //     huddleTagData.push(data);
          
      //   });

       
      // })
      firebase.database().ref('houses').once('value', (snapshot) => {
        snapshot.forEach((childSnapshot) => {
            var _data = childSnapshot.val();
            _data.key = childSnapshot.key;
            let data={
              value:  childSnapshot.key ,
              label:  _data.name ,
              type:'houses'
            }
            if(childSnapshot.key){
              state.huddleTag[childSnapshot.key]=data
            }
            huddleTagData.push(data);
        })
        huddleTagData = _.sortBy(huddleTagData, ["type", "label"]);
        // console.log("huddleTagData",huddleTagData)
        commit('setHuddleTag', huddleTagData)

      })
    },
    async getComment({commit,rootState,dispatch,state}:any,obj:any){
      let comment:Array<any>=[]
      await firebase.firestore().collection(`classrooms/${obj.id}/comments`).get()
          .then((querySnapshot)=> {
              querySnapshot.forEach((doc) => {
                  let classrooms = doc.data()
                  classrooms.key = doc.id
                  let liked=_.find(classrooms.likeusers, function(o) { return o==rootState.authen.user.email });
                  if(liked){
                    classrooms.liked=true
                  }else{
                    classrooms.liked=false
                  }
                  if(state.userAll[classrooms.user]){
                    
                    classrooms.creatorImageProfile=state.userAll[classrooms.user].profilepic_crop||""
                  }else{
                    classrooms.creatorImageProfile=""
                  }
                  
                  let subComment:Array<any>=[]
                  if(classrooms.comments>0){
                    firebase.firestore().collection(`classrooms/${obj.id}/comments/${doc.id}/comments`).get()
                    .then((_querySnapshot)=> {
                        _querySnapshot.forEach((_doc) => {
                            const _classrooms = _doc.data()
                            _classrooms.key = _doc.id
                            let _liked=_.find(_classrooms.likeusers, function(o) { return o==rootState.authen.user.email });
                            
                            if(state.userAll[_classrooms.user]){
                              _classrooms.creatorImageProfile=state.userAll[_classrooms.user].profilepic_crop||""
                            }else{
                              _classrooms.creatorImageProfile=""
                            }

                            if(_liked){
                              _classrooms.liked=true
                            }else{
                              _classrooms.liked=false
                            }
                            subComment.push(_classrooms)
                            
                    })
                    const _subComment=_.orderBy(subComment, [(obj) => {return new Date(obj.createdate)}], ['asc'])
                    comment.push({...classrooms,subComment:_subComment})
                  })
                    
                }else{
                  
                  comment.push({...classrooms,subComment:[]})
                }
                  
          })
          //console.log("comment",comment)
          commit('setComment',comment)
    })
    },
    async replyComment({commit,rootState,dispatch,state}:any,obj:any){
      let data={
        comments: 0,
        company: rootState.authen.user.company,
        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
        like: 0,
        likeorder:obj.likeorder,//parseInt('9999'+moment().utc().add(rootState.authen.user.timezone,'hours').format("YYYYMMDDHHmmss")),
        mparent_id:obj.sessionId,
        maprent_id2:obj.comment.key,
        name:rootState.authen.user.firstname+" "+rootState.authen.user.lastname.charAt(0),
        notifications: obj.notifications?obj.notifications:[],
        type: "session",
        user: rootState.authen.user.email,
        value:obj.message}
        await firebase.firestore().collection(`classrooms/${obj.sessionId}/comments/${obj.comment.key}/comments`).add(data).then(()=>{
        });
    },
    async comment({commit,rootState,dispatch,state}:any,obj:any){
      let data={
        comments: 0,
        company: rootState.authen.user.company,
        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
        like: 0,
        likeorder:obj.likeorder,//parseInt('9999'+moment().utc().add(rootState.authen.user.timezone,'hours').format("YYYYMMDDHHmmss")),
        mparent_id:obj.sessionId,
        name:rootState.authen.user.firstname+" "+rootState.authen.user.lastname.charAt(0),
        notifications:obj.notifications?obj.notifications:[],
        type: "session",
        user: rootState.authen.user.email,
        value:obj.message}
 
        await firebase.firestore().collection(`classrooms/${obj.sessionId}/comments`).add(data).then((docRef)=>{
      
        commit('setCommentID',docRef.id)
      })
    },
    async likeOrUnLike({commit,rootState,dispatch,state}:any,obj:any){
        let like =obj.form.like;
        let likeorder = obj.form.likeorder;

        if(obj.form.liked === true){

          like = like-1;
          const likeordertmp = likeorder.toString().substring(0, 4);
          likeorder = parseInt(String((Number(likeordertmp))+1)+moment().utc().add(rootState.authen.user.timezone,'hours').format("YYYYMMDDHHmmss"));
          var docref =await firebase.firestore().collection(`classrooms/${obj.form.mparent_id}/comments`).doc(obj.form.key);

          docref.update({
            likeusers:firebase.firestore.FieldValue.arrayRemove(rootState.authen.user.email),
            like:firebase.firestore.FieldValue.increment(-1),
            likeorder:likeorder
          });
        }else{

          like = like+1;
          const likeordertmp = likeorder.toString().substring(0, 4);
          likeorder = parseInt(String((Number(likeordertmp))-1)+moment().utc().add(rootState.authen.user.timezone,'hours').format("YYYYMMDDHHmmss"));
          
        const docref =await firebase.firestore().collection(`classrooms/${obj.form.mparent_id}/comments`).doc(obj.form.key);
     
          docref.update({
            likeusers:firebase.firestore.FieldValue.arrayUnion(rootState.authen.user.email),
            like:firebase.firestore.FieldValue.increment(1),
            likeorder:likeorder
          });
        }
   
    },
    async replylikeOrUnlike({commit,rootState,dispatch,state}:any,obj:any){
        let like =obj.form.like;
        let likeorder = obj.form.likeorder;

        if(obj.form.liked === true){
          like = like-1;
          const likeordertmp = likeorder.toString().substring(0, 4);
          likeorder = parseInt(String((Number(likeordertmp))+1)+moment().utc().add(rootState.authen.user.timezone,'hours').format("YYYYMMDDHHmmss"));
          var docref =await firebase.firestore().collection(`classrooms/${obj.form.mparent_id}/comments/${obj.form.maprent_id2}/comments`).doc(obj.form.key);

          docref.update({
            likeusers:firebase.firestore.FieldValue.arrayRemove(rootState.authen.user.email),
            like:firebase.firestore.FieldValue.increment(-1),
            likeorder:likeorder
          });
        }else{

          like = like+1;
          const likeordertmp = likeorder.toString().substring(0, 4);
          likeorder = parseInt(String((Number(likeordertmp))-1)+moment().utc().add(rootState.authen.user.timezone,'hours').format("YYYYMMDDHHmmss"));
        const docref =await firebase.firestore().collection(`classrooms/${obj.form.mparent_id}/comments/${obj.form.maprent_id2}/comments`).doc(obj.form.key);
          docref.update({
            likeusers:firebase.firestore.FieldValue.arrayUnion(rootState.authen.user.email),
            like:firebase.firestore.FieldValue.increment(1),
            likeorder:likeorder
          });
        }
   
    },
    async getUser({commit,rootState,dispatch,state}:any,obj:any){
      let userAll={}
      let member:Array<any>=[]
      const allUser = await getUserAll(obj.company)
      for(const doc in allUser){
        let data = allUser[doc]
        if(data.email){
          userAll[data.email]=data
         
        }
        data.fullname=data.firstname+" "+data.lastname
        data.name=data.firstname+" "+data.lastname
        data.id=doc
        member.push(data)
      }
      commit('setMember',member)
      commit('setUserAll',userAll)
      // firebase.database().ref(`users`).orderByChild("company").equalTo(rootState.authen.user.company).once('value', snapshot => {
      //   snapshot.forEach((doc):any => {
      //       let data=doc.val()
      //       if(data.email){
      //         userAll[data.email]=data
             
      //       }
      //       data.fullname=data.firstname+" "+data.lastname
      //       data.name=data.firstname+" "+data.lastname
      //       data.id=doc.key
      //       member.push(data)
      //   });
      //   //console.log("member",member)
      //   commit('setMember',member)
      //   commit('setUserAll',userAll)
      // })
    },
    // Campaigns actions (mock only - no Firebase)
    async fetchCampaignsMock({commit, rootState}:any) {
      // TODO(backend): Replace with actual backend service call
      // For now, return mock data for UI development
      commit('setLoadingCampaigns', true);
      
      // Simulate network delay
      await new Promise(resolve => setTimeout(resolve, 500));
      
      const mockCampaigns = [
        {
          id: 'camp-1',
          company: rootState.authen.user.company,
          title: 'Product Knowledge Quiz',
          iconKey: 'ic_star_24px',
          theme: { gradientKey: 'purple', accentHex: '#7D5ABA' },
          inputType: 'quiz',
          timing: { 
            frequency: 'daily', 
            startDate: new Date().toISOString(), 
            endDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
            occurrences: 30
          },
          goals: { 
            dailyEnabled: true, 
            dailyTarget: 1,
            individualEnabled: true, 
            individualTarget: 7, 
            groupEnabled: false 
          },
          reward: { type: 'instant', coins: 10 },
          entryCost: 5,
          status: 'active',
          createdBy: rootState.authen.user.email,
          createdAt: new Date().toISOString(),
          participants: 42
        },
        {
          id: 'camp-2',
          company: rootState.authen.user.company,
          title: 'Steps Challenge',
          iconKey: 'ic_bolt_purple_24dp',
          theme: { gradientKey: 'blue', accentHex: '#5682A3' },
          inputType: 'auto_sync_steps',
          timing: { 
            frequency: 'daily', 
            startDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(), 
            endDate: new Date(Date.now() + 37 * 24 * 60 * 60 * 1000).toISOString(),
            occurrences: 30
          },
          goals: { 
            dailyEnabled: true,
            dailyTarget: 10000,
            individualEnabled: true, 
            individualTarget: 300000, 
            groupEnabled: true, 
            groupTarget: 10000000 
          },
          reward: { type: 'prize_pool' },
          entryCost: 20,
          status: 'upcoming',
          createdBy: rootState.authen.user.email,
          createdAt: new Date().toISOString(),
          participants: 0
        }
      ];
      
      commit('setCampaigns', mockCampaigns);
      commit('setLoadingCampaigns', false);
    },
    async createCampaignDraft({commit, rootState}:any, form:any) {
      // TODO(backend): Integrate with backend service to create campaign
      const newCampaign = {
        id: 'camp-' + Date.now(),
        company: rootState.authen.user.company,
        ...form,
        status: 'draft',
        createdBy: rootState.authen.user.email,
        createdAt: new Date().toISOString(),
        participants: 0
      };
      commit('upsertCampaign', newCampaign);
    },
    async editCampaignDraft({commit}:any, {id, form}:any) {
      // TODO(backend): Integrate with backend service to update campaign
      const updatedCampaign = {
        ...form,
        id,
      };
      commit('upsertCampaign', updatedCampaign);
    },
    async archiveCampaignDraft({commit}:any, id:any) {
      // TODO(backend): Integrate with backend service to archive campaign
      commit('archiveCampaignLocal', id);
    },
    // Helper to get gradient colors from theme
    getThemeColors(_context:any, theme:any) {
      const gradients:any = {
        purple: { start: "#FAF5FF", end: "#B097D8" },
        yellow: { start: "#FFFCDD", end: "#FDE456" },
        pink: { start: "#FFFAFF", end: "#FF9AE3" },
        green: { start: "#DDFFF6", end: "#68BCAC" },
        orange: { start: "#FFE9DD", end: "#FDB056" },
      };
      const accentColors:any = {
        purple: "#360065",
        yellow: "#6E5518",
        pink: "#6E1861",
        green: "#00654B",
        orange: "#6E4018",
      };
      const gradientKey = (theme && theme.gradientKey) || "purple";
      const gradient = gradients[gradientKey] || gradients.purple;
      return {
        gradientStart: gradient.start,
        gradientEnd: gradient.end,
        accentColor: accentColors[gradientKey] || accentColors.purple,
      };
    },
    async createCampaign({commit, rootState, state}:any, obj:any) {
      const db = firebase.firestore();
      const form = obj.form;
      const huddles = obj.huddles || [];

      // Process huddles - same pattern as createSession and createTopic
      // Convert cascader format [[key], [key]] to structured huddle objects
      let huddle: any[] = [];
      const hasEveryone = huddles.some((v:any) => v && v[0] === 'everyone');
      
      // Only process huddles when NOT everyone (when scoped to specific teams/cohorts)
      if (!hasEveryone) {
        huddles.forEach((v:any) => {
          if (!v || !v[0] || v[0] === 'everyone') return;
          const huddleKey = v[0];
          const huddleData = state.huddleTag[huddleKey];
          if (huddleData) {
            if (huddleData.type === "houses") {
              huddle.push({
                key: huddleData.value,
                value: huddleData.label,
                selected: true,
                show: true,
                house: true
              });
            } else {
              huddle.push({
                key: huddleData.value,
                value: huddleData.label,
                selected: true,
                show: true,
                team: true
              });
            }
          }
        });
      }

      // Get theme colors
      const gradients:any = {
        purple: { start: "#FAF5FF", end: "#B097D8" },
        yellow: { start: "#FFFCDD", end: "#FDE456" },
        pink: { start: "#FFFAFF", end: "#FF9AE3" },
        green: { start: "#DDFFF6", end: "#68BCAC" },
        orange: { start: "#FFE9DD", end: "#FDB056" },
      };
      const accentColors:any = {
        purple: "#360065",
        yellow: "#6E5518",
        pink: "#6E1861",
        green: "#00654B",
        orange: "#6E4018",
      };
      const gradientKey = (form.theme && form.theme.gradientKey) || "purple";
      const gradient = gradients[gradientKey] || gradients.purple;

      // Process multilingual fields for backward compatibility
      const processedForm = processMultilingualFields(form);

      const campaignData: any = {
        ...processedForm,
        // Transform theme to individual fields
        gradientStart: gradient.start,
        gradientEnd: gradient.end,
        accentColor: accentColors[gradientKey] || accentColors.purple,
        // Keep original theme for reference
        theme: form.theme,
        // Add metadata
        company: rootState.authen.user.company,
        status: 'active',
        createdBy: rootState.authen.user.email,
        createdAt: new Date().toISOString(),
        participants: 0,
      };

      // Only add huddles when scoped to specific teams/cohorts (not "everyone")
      if (!hasEveryone && huddle.length > 0) {
        campaignData.huddles = huddle;
        campaignData.delete = "huddles";
      }

      const docRef = await db.collection('universityCampaigns').add(campaignData);
      const newCampaign = { id: docRef.id, ...campaignData };
      commit('upsertCampaign', newCampaign);
      return newCampaign;
    },
    async updateCampaign({commit, state}:any, {id, form, huddles}:any) {
      const db = firebase.firestore();
      const huddlesData = huddles || [];

      // Process huddles - same pattern as createSession and createTopic
      // Convert cascader format [[key], [key]] to structured huddle objects
      let huddle: any[] = [];
      const hasEveryone = huddlesData.some((v:any) => v && v[0] === 'everyone');
      
      // Only process huddles when NOT everyone (when scoped to specific teams/cohorts)
      if (!hasEveryone) {
        huddlesData.forEach((v:any) => {
          if (!v || !v[0] || v[0] === 'everyone') return;
          const huddleKey = v[0];
          const huddleData = state.huddleTag[huddleKey];
          if (huddleData) {
            if (huddleData.type === "houses") {
              huddle.push({
                key: huddleData.value,
                value: huddleData.label,
                selected: true,
                show: true,
                house: true
              });
            } else {
              huddle.push({
                key: huddleData.value,
                value: huddleData.label,
                selected: true,
                show: true,
                team: true
              });
            }
          }
        });
      }

      // Get theme colors
      const gradients:any = {
        purple: { start: "#FAF5FF", end: "#B097D8" },
        yellow: { start: "#FFFCDD", end: "#FDE456" },
        pink: { start: "#FFFAFF", end: "#FF9AE3" },
        green: { start: "#DDFFF6", end: "#68BCAC" },
        orange: { start: "#FFE9DD", end: "#FDB056" },
      };
      const accentColors:any = {
        purple: "#360065",
        yellow: "#6E5518",
        pink: "#6E1861",
        green: "#00654B",
        orange: "#6E4018",
      };
      const gradientKey = (form.theme && form.theme.gradientKey) || "purple";
      const gradient = gradients[gradientKey] || gradients.purple;

      // Process multilingual fields for backward compatibility
      const processedForm = processMultilingualFields(form);

      const campaignData: any = {
        ...processedForm,
        // Transform theme to individual fields
        gradientStart: gradient.start,
        gradientEnd: gradient.end,
        accentColor: accentColors[gradientKey] || accentColors.purple,
        // Keep original theme for reference
        theme: form.theme,
        updatedAt: new Date().toISOString(),
      };

      // Only add huddles when scoped to specific teams/cohorts (not "everyone")
      if (!hasEveryone && huddle.length > 0) {
        campaignData.huddles = huddle;
        campaignData.delete = "huddles";
      } else if (hasEveryone) {
        // When switching to "everyone", remove the huddles field from Firebase
        campaignData.huddles = firebase.firestore.FieldValue.delete();
      }

      await db.collection('universityCampaigns').doc(id).update(campaignData);
      const updatedCampaign = { id, ...campaignData };
      commit('upsertCampaign', updatedCampaign);
      return updatedCampaign;
    },
    async fetchCampaigns({commit, rootState}:any) {
      commit('setLoadingCampaigns', true);
      try {
        const db = firebase.firestore();
        const snapshot = await db.collection('universityCampaigns')
          .where('company', '==', rootState.authen.user.company)
          .orderBy('createdAt', 'desc')
          .get();

        const campaigns = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        commit('setCampaigns', campaigns);
      } catch (error) {
        console.error('Error fetching campaigns:', error);
      } finally {
        commit('setLoadingCampaigns', false);
      }
    },
    async archiveCampaign({commit}:any, id:any) {
      const db = firebase.firestore();
      await db.collection('universityCampaigns').doc(id).update({
        status: 'archived',
        archivedAt: new Date().toISOString(),
      });
      commit('archiveCampaignLocal', id);
    },
    async fetchCampaignSummaries({commit, rootState}:any) {
      try {
        const db = firebase.firestore();
        const snapshot = await db.collection('campaign_overall_summary')
          .where('company', '==', rootState.authen.user.company)
          .get();
        
        const summaries: Record<string, any> = {};
        snapshot.docs.forEach(doc => {
          const data = doc.data();
          // Index by campaign_id for easy lookup
          if (data.campaign_id) {
            summaries[data.campaign_id] = {
              id: doc.id,
              ...data,
              participantCount: data.leaderboard ? data.leaderboard.length : 0
            };
          }
        });
        
        commit('setCampaignSummaries', summaries);
        return summaries;
      } catch (error) {
        console.error('Error fetching campaign summaries:', error);
        return {};
      }
    },
    async fetchCampaignSummary({commit, rootState}:any, campaignId:string) {
      try {
        const db = firebase.firestore();
        const snapshot = await db.collection('campaign_overall_summary')
          .where('campaign_id', '==', campaignId)
          .where('company', '==', rootState.authen.user.company)
          .limit(1)
          .get();
        
        if (!snapshot.empty) {
          const doc = snapshot.docs[0];
          const data = doc.data();
          
          const summary = {
            id: doc.id,
            ...data,
            participantCount: data.leaderboard ? data.leaderboard.length : 0
          };
          commit('setCampaignSummary', { campaignId, summary });
          return summary;
        }
        return null;
      } catch (error) {
        console.error('Error fetching campaign summary:', error);
        return null;
      }
    },
    async fetchCampaignSignups({commit, rootState}:any, campaignId:string) {
      try {
        const db = firebase.firestore();
        const snapshot = await db.collection('universityCampaigns')
          .doc(campaignId)
          .collection('participants')
          .get();
        
        // Get all users and teams to enrich signup data
        const allUsers = rootState.main.allUser || {};
        const teams = await getTeamByCompany(rootState.authen.user.company);
        
        const signups: any[] = [];
        snapshot.docs.forEach(doc => {
          const data = doc.data();
          const email = data.email || doc.id;
          
          // Look up user details from allUsers
          const emailKey = email.replace(/\./g, '||');
          const user = allUsers[emailKey] || {};
          
          // Get team name
          let teamName = data.team_name || data.teamName || '';
          if (!teamName && user.team && teams[user.team]) {
            teamName = teams[user.team].name || '';
          }
          
          // Get profile picture
          let photoUrl = data.photo_url || data.photoURL || '';
          if (!photoUrl && user) {
            photoUrl = user.profilepic_small || user.profilepic_crop || user.profilepic || '';
          }
          
          // Get name
          let name = data.name || data.displayName || '';
          if (!name && user.firstname) {
            name = `${user.firstname} ${user.lastname || ''}`.trim();
          }
          
          signups.push({
            id: doc.id,
            email: email,
            name: name || email,
            photo_url: photoUrl,
            team_name: teamName,
            joinedAt: data.joinedAt || data.createdAt || null,
            ...data
          });
        });
        
        // Sort by join date, newest first
        signups.sort((a, b) => {
          const dateA = a.joinedAt ? (a.joinedAt.toDate ? a.joinedAt.toDate() : new Date(a.joinedAt)) : new Date(0);
          const dateB = b.joinedAt ? (b.joinedAt.toDate ? b.joinedAt.toDate() : new Date(b.joinedAt)) : new Date(0);
          return dateB.getTime() - dateA.getTime();
        });
        
        return signups;
      } catch (error) {
        console.error('Error fetching campaign signups:', error);
        return [];
      }
    },
  },
  getters: {
    sessions: (state) => {
      let sessions = state.sessions_all;
      let newSessions = sessions.map((session, index) => {
        let time = session.class_datetime;
        let class_datetime = time.split(" at").join(",");
        return {
          ...session,
          timestamp: new Date(class_datetime.substring(0, class_datetime.length - 3)).getTime(),
          commentsall: session.commentsall || 0
        };
      });
      let field = state.sessionSortField;
      let order = state.sessionSortOrder === "ascending" ? "desc" : "asc";
      if (field === "signup" || field === "class_price" || field === "class_datetime") {
        order = state.sessionSortOrder === "ascending" ? "desc" : "asc";
      }
      if(field === ""){
        field = "create_date"
      }
      let newSessionsSorted:any = _.orderBy(newSessions, [field], [order]);

      let size = state.size_page;
      let page = state.sessionPage;
      let start_row = (page - 1) * size;
      let end_row = ((page - 1) * size) + size;
      let sessionsPageShowing: Array<any> = [];

      if (state.inputSearchSessions.length > 2) {
        let re = new RegExp(state.inputSearchSessions, 'gi');

        let response:any = _.filter(newSessionsSorted, (item): any => {
          if (item && item.class_name && item.class_name.match(re)) {
            return true;
          } else if (item && item.create_name && item.create_name.match(re)) {
            return true;
          } else if (item && item.topic_name && item.topic_name.match(re)) {
            return true;
          }
        });
        sessionsPageShowing = response;
      } else {
        sessionsPageShowing = newSessionsSorted
      }
      return sessionsPageShowing.slice(start_row, end_row) || []
    },
    sessions_all: ({ sessions_all }) => {
      return sessions_all
    },
    inputSearchSessions: ({ inputSearchSessions }) => {
      return inputSearchSessions
    },
    sessionResults: ({ sessionResults }) => {
      return sessionResults
    },
    topicOpt: ({topicOpt}) => {
      return topicOpt
    },
    university: ({university}) => {
        return university
    },
    universityall: ({universityall}) => {
        return universityall
    },
    university_graphmonth: ({university_graphmonth}) => {
        return university_graphmonth
    },
    university_graphmonth16: ({university_graphmonth16}) => {
        return university_graphmonth16
    },
    university_total: ({university_total}) => {
        return university_total
    },
    university_total16: ({university_total16}) => {
        return university_total16
    },
    loadingUniversitySessionsTable: ({loadingUniversitySessionsTable}) => {
      return loadingUniversitySessionsTable
    },
    huddleTagData:({ huddleTagData }) => {
      return huddleTagData
    },
    comment:({ comment }) => {
      comment = _.sortBy(comment, function(dateObj) {
        return new Date(dateObj.createdate);
      });
      return comment
    },
    commentId:({ commentId }) => {
      return commentId
    },
    userAll:({ userAll }) => {
      return userAll
    },
    member:({ member }) => {
      return member
    },
    organization1level:(state:any) => {
      return state.organization1level
    },
    // Campaigns getters
    campaigns: (state:any) => {
      return state.campaigns;
    },
    campaignsCount: (state:any) => {
      return state.campaigns_all.length;
    },
    loadingCampaigns: (state:any) => {
      return state.loadingCampaigns;
    },
    campaignSummaries: (state:any) => {
      return state.campaignSummaries;
    },
    getCampaignSummary: (state:any) => (campaignId:string) => {
      return state.campaignSummaries[campaignId] || null;
    },
  }
}